export type CardSuit = '♠' | '♥' | '♣' | '♦' | '';
export type CardValue = '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | 'J' | 'Q' | 'K' | 'A' | '2' | 'joker_small' | 'joker_big';

export enum CardGenre {
    Single = 1,
    Straight = 2,
    Pair = 3,
    TriplePair = 4,
    Triple = 5,
    TripleStraight = 6,
    ThreeWithTwo = 7,
    Bomb4 = 8,
    Bomb5 = 9,
    StraightFlush = 10,
    Bomb6 = 11,
    Bomb7 = 12,
    Bomb8 = 13,
    Bomb9 = 14,
    Bomb10 = 15,
    JokerBomb = 16,
}

export interface Card {
    id: string;
    suit: CardSuit;
    value: CardValue;
    valueNum: number;
    isRedHeart?: boolean;
    isLevelCard?: boolean;
}

export type HandCards = Card[];

export interface GenreResult {
    genre: CardGenre;
    mainValue: number;
    subValue?: number;
    cardCount: number;
    cards: Card[];
}

export type SeatPosition = 0 | 1 | 2 | 3;

export interface Player {
    id: string;
    name: string;
    seat: SeatPosition;
    isAI: boolean;
    aiDifficulty?: 'easy' | 'normal' | 'hard';
    hand: HandCards;
    isReady: boolean;
    passed: boolean;
    avatar: string;
    gold: number;
    diamond: number;
    team: 'red' | 'blue';
}

export type RoomStatus = 'waiting' | 'ready' | 'playing' | 'finished';
export type GamePhase = 'idle' | 'tribute' | 'refund' | 'playing' | 'scoring';

export interface Room {
    id: number;
    name: string;
    creatorId: string;
    status: RoomStatus;
    phase: GamePhase;
    players: (Player | null)[];
    currentLevel: number;
    currentTurn: SeatPosition;
    lastPlay: GenreResult | null;
    lastPlayer: SeatPosition | null;
    winner: 'red' | 'blue' | null;
    createdAt: number;
    remaining?: Card[];
}

export const GENRE_NAMES: Record<CardGenre, string> = {
    [CardGenre.Single]: '单张',
    [CardGenre.Straight]: '顺子',
    [CardGenre.Pair]: '对子',
    [CardGenre.TriplePair]: '三连对',
    [CardGenre.Triple]: '三张',
    [CardGenre.TripleStraight]: '钢板',
    [CardGenre.ThreeWithTwo]: '三带二',
    [CardGenre.Bomb4]: '4炸',
    [CardGenre.Bomb5]: '5炸',
    [CardGenre.StraightFlush]: '同花顺',
    [CardGenre.Bomb6]: '6炸',
    [CardGenre.Bomb7]: '7炸',
    [CardGenre.Bomb8]: '8炸',
    [CardGenre.Bomb9]: '9炸',
    [CardGenre.Bomb10]: '10炸',
    [CardGenre.JokerBomb]: '王炸',
};